import laravelAxiosClient from "../laravelAxiosClient";
import {
  CreateAjoutRuchesStripeSessionPayload,
  CreateAjoutRuchesStripeSessionResult,
  CreateProduitDigitalStripeSessionPayload,
  CreateProduitDigitalStripeSessionResult,
  ValiderPaiementSessionPayload,
  ValiderPaiementSessionResult,
} from "../interfaces/paiement.interface";

export const validerPaiementSession = async (payload: ValiderPaiementSessionPayload) => {
  const { data } = await laravelAxiosClient.post<ValiderPaiementSessionResult>(
    "/paiement/valider-paiement-session",
    payload,
  );
  return data;
};

export const createAjoutRuchesStripeSession = async (payload: CreateAjoutRuchesStripeSessionPayload) => {
  const { data } = await laravelAxiosClient.post<CreateAjoutRuchesStripeSessionResult>(
    "/paiement/creer-stripe-checkout-session-pour-ajout-ruches",
    payload,
  );
  return data;
};

export const createProduitDigitalStripeSession = async (payload: CreateProduitDigitalStripeSessionPayload) => {
  const { data } = await laravelAxiosClient.post<CreateProduitDigitalStripeSessionResult>(
    "/paiement/creer-stripe-checkout-session-pour-produit-digital",
    payload,
  );
  return data;
};
